import { render, staticRenderFns } from "./ProductsSell.vue?vue&type=template&id=8ef6d074&"
import script from "./ProductsSell.vue?vue&type=script&lang=js&"
export * from "./ProductsSell.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports